// extracted by mini-css-extract-plugin
module.exports = {"description":"description_gi2hA","loading":"loading_z13ia"};